<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
      alt="Close Icon">
    <div class="modal-header">
      <h4 class="modal-heading">{{data?.title || 'Add a New Address'}}</h4>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <app-address-lookup #addressLookup (isValid)="setValidAddress($event)" [showAlias]="true" [populateForm]="!!data?.displayedAddress"
          [displayedAddress]="data?.displayedAddress || {}" (addressChange)="addressLookUpChanged($event)" [touchForm]="touchShippimgForm"
          [resetForm]="resetAddressForm">
        </app-address-lookup>
      </div>

      <div class="modal-actions">
        <button class="button primary" (click)="save()">Save</button>
        <button class="button tertiary" (click)="closeDialog()">Cancel</button>
      </div>
    </div>
  </div>
</div>
